import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ModalBootstrap from '../../../componentes/modal/ModalBootstrap';
import { mostraAlertaError, mostraAlertaOk } from '../../../componentes/alerts/sweetAlert';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment/locale/es';
import { InventariosTiposListar } from "../../../configuracion/apiUrls";
import { AxiosPrivado } from '../../../componentes/axios/Axios';
import { ErroresPeticion } from '../../../componentes/axios/ErroresPeticion';
import { ca } from 'zod/v4/locales';

moment.locale('es');

const ModalLoteProducto = ({ producto, onSave }) => {
    const [listaInventariosTipos, setListaInventariosTipos] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errorLoteFechaIngreso, setErrorLoteFechaIngreso] = useState(false);
    const [errorLoteCosto, setErrorLoteCosto] = useState(false);
    const [errorLotePrecio, setErrorLotePrecio] = useState(false);
    const [errorLoteCantidad, setErrorLoteCantidad] = useState(false);
    const [errorLotesPrecios, setErrorLotesPrecios] = useState(false);
    const [errorLotesInventario, setErrorLotesInventario] = useState(false);

    const [formularioLote, setFormularioLote] = useState({
        nombre_lote: '',
        fecha_ingreso: moment().toDate(),
        costo: "",
        precio: "",
        utilidad: "0.00",
        estado: 'Disponible',
        cantidad: "",
        existencia: "",
        enPedido: 0,
    });
    const [lotesPrecios, setLotesPrecios] = useState([]);
    const [lotesInventario, setLotesInventario] = useState([]);

    console.log("Producto recibido en ModalLoteProducto:", producto);

    useEffect(() => {
        const cargarInventariosTipos = async () => {
            try {
                const response = await AxiosPrivado.get(InventariosTiposListar);
                if (response.data && Array.isArray(response.data)) {
                    setListaInventariosTipos(response.data);
                } else {
                    mostraAlertaError("La estructura de la respuesta de inventarios no es la esperada.");
                }
            } catch (error) {
                mostraAlertaError(ErroresPeticion(error, "Error al cargar tipos de inventario"));
            }
        };

        if (modalIsOpen && listaInventariosTipos.length === 0) {
            cargarInventariosTipos();
        }

    }, [modalIsOpen, listaInventariosTipos.length]);

    useEffect(() => {
        if (modalIsOpen && producto) {
            const initialCantidad = String(producto?.lote?.cantidad || "");
            const initialExistencia = String(producto?.lote?.existencia || initialCantidad);

            setFormularioLote({
                nombre_lote: producto?.lote?.nombre_lote || '',
                fecha_ingreso: producto?.lote?.fecha_ingreso ? moment(producto.lote.fecha_ingreso).toDate() : moment().toDate(),
                costo: String(producto?.lote?.costo || "0.00"),
                precio: String(producto?.lote?.precio || "0.00"),
                utilidad: String(producto?.lote?.utilidad || "0.00"),
                estado: producto?.lote?.estado || 'Disponible',
                cantidad: initialCantidad,
                existencia: initialExistencia,
                enPedido: producto?.lote?.enPedido || 0,
            });
            setLotesPrecios(producto?.lote?.lotesPrecios?.map(lp => ({
                cantidad: String(lp.cantidad),
                precio: String(lp.precio)
            })) || []);

            setLotesInventario(producto?.lote?.lotesInventario?.map(li => ({
                existencia: String(li.existencia),
                inventarioTipoId: String(li.inventarioTipoId),
                estado: li.estado
            })) || []);
        }
    }, [modalIsOpen, producto]);

    useEffect(() => {
        const precio = parseFloat(formularioLote.precio) || 0;
        const costo = parseFloat(formularioLote.costo) || 0;
        const calculatedUtilidad = (precio - costo).toFixed(2);
        const cantidadLote = formularioLote.cantidad;

        setFormularioLote(prev => {
            const updates = {};
            if (calculatedUtilidad !== prev.utilidad) {
                updates.utilidad = calculatedUtilidad;
            }
            if (cantidadLote !== prev.existencia) {
                updates.existencia = cantidadLote;
            }
            return Object.keys(updates).length > 0 ? { ...prev, ...updates } : prev;
        });

        setErrorLoteFechaIngreso(!formularioLote.fecha_ingreso);
        setErrorLoteCosto(isNaN(parseFloat(formularioLote.costo)) || parseFloat(formularioLote.costo) < 0);
        setErrorLotePrecio(isNaN(parseFloat(formularioLote.precio)) || parseFloat(formularioLote.precio) < 0);
        const cantidadEnteraValida = /^\d+$/.test(formularioLote.cantidad) && parseInt(formularioLote.cantidad) > 0;
        setErrorLoteCantidad(!cantidadEnteraValida);

        const totalExistenciaLote = parseInt(formularioLote.existencia) || 0;
        const totalAsignado = lotesInventario.reduce((sum, item) => {
            return sum + (parseInt(item.existencia) || 0);
        }, 0);

        const totalAsignacionExceeded = totalAsignado > totalExistenciaLote;

        const errorInRows = lotesInventario.some(item => {
            const existencia = parseInt(item.existencia);
            return existencia < 0 || item.existencia === "" || !item.inventarioTipoId;
        });

        setErrorLotesInventario(errorInRows || totalAsignacionExceeded);

        const errorInLotesPrecios = lotesPrecios.some(item => {
            const cantidad = parseInt(item.cantidad);
            const precio = parseFloat(item.precio);
            const cantidadInvalida = (!Number.isInteger(cantidad) || cantidad < 1 || item.cantidad === "");
            const precioInvalido = (isNaN(precio) || precio < 0 || item.precio === "");

            return cantidadInvalida || precioInvalido;
        });

        setErrorLotesPrecios(errorInLotesPrecios);

    }, [formularioLote, lotesPrecios, lotesInventario]);

    const manejarCambio = (e) => {
        const { name, value } = e.target;
        setFormularioLote({ ...formularioLote, [name]: value });
    };

    const manejarLotePrecio = (index, field, value) => {
        const arr = (lotesPrecios || []).map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setLotesPrecios(arr);
    };

    const agregarLotePrecio = () => {
        setLotesPrecios([...lotesPrecios, { cantidad: "", precio: "" }]);
    };

    const eliminarLotePrecio = (index) => {
        setLotesPrecios(lotesPrecios.filter((_, i) => i !== index));
    };

    const agregarLoteInventario = () => {
        setLotesInventario([
            ...lotesInventario,
            { existencia: "", inventarioTipoId: "", estado: "Activo" },
        ]);
    };

    const eliminarLoteInventario = (index) => {
        setLotesInventario(lotesInventario.filter((_, i) => i !== index));
    };

    const handleLoteInventarioChange = (index, field, value) => {
        setLotesInventario(prev => {
            const arr = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            return arr;
        });
    };

    const validarFormulario = () => {
        if (errorLoteFechaIngreso || errorLoteCosto || errorLotePrecio || errorLoteCantidad || errorLotesPrecios || errorLotesInventario) {
            mostraAlertaError('Existen errores en los datos del lote, precios por mayoreo o asignación de inventario');
            return false;
        }
        return true;
    };

    const guardar = () => {
        if (!validarFormulario()) return;
        const nuevoProducto = {
            ...producto,
            precio: parseFloat(formularioLote.precio) || 0,
            costo: parseFloat(formularioLote.costo) || 0,
            cantidad: parseInt(formularioLote.cantidad) || 0,
        };
        const nuevoLote = {
            ...formularioLote,
            fecha_ingreso: moment(formularioLote.fecha_ingreso).format('YYYY-MM-DD'),
            costo: parseFloat(formularioLote.costo) || 0,
            precio: parseFloat(formularioLote.precio) || 0,
            utilidad: parseFloat(formularioLote.utilidad) || 0,
            cantidad: parseInt(formularioLote.cantidad) || 0,
            existencia: parseInt(formularioLote.cantidad) || 0,
            enPedido: parseInt(formularioLote.enPedido) || 0,
            lotesPrecios: lotesPrecios.map(lp => ({
                cantidad: parseInt(lp.cantidad) || 0,
                precio: parseFloat(lp.precio) || 0,
            })),
            lotesInventarios: lotesInventario.map(li => ({
                existencia: parseInt(li.existencia) || 0,
                inventarioTipoId: parseInt(li.inventarioTipoId) || 0,
                estado: li.estado,
            })),
        };

        onSave({ ...nuevoProducto, lote: nuevoLote });
        mostraAlertaOk("Lote guardado correctamente");
        setModalIsOpen(false);
    };

    const BotonGuardar = () => (
        <button type="button" className="btn btn-success" onClick={guardar} disabled={errorLotesPrecios || errorLoteCantidad || errorLotesInventario}>
            Guardar Lote
        </button>
    );

    return (
        <ModalBootstrap
            titulo={"Nuevo Lote y Precios del Producto"}
            estiloBoton={"btn btn-info"}
            iconBoton={"fas fa-box mx-1"}
            pie={<BotonGuardar />}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size={"lg"}
        >
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        <div className="form-group">
                            <label htmlFor="nombre_lote" className="form-label">Nombre del lote</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nombre_lote"
                                name="nombre_lote"
                                placeholder="Ej. Lote A1"
                                value={formularioLote.nombre_lote}
                                onChange={manejarCambio}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="fecha_ingreso" className="form-label d-block">Fecha de ingreso</label>
                            <DatePicker
                                selected={formularioLote.fecha_ingreso}
                                onChange={(date) =>
                                    setFormularioLote({
                                        ...formularioLote,
                                        fecha_ingreso: date
                                    })
                                }
                                dateFormat="yyyy-MM-dd"
                                className={`form-control ${errorLoteFechaIngreso ? "is-invalid" : ""}`}
                                wrapperClassName="w-100"
                                id="fecha_ingreso"
                            />
                            {errorLoteFechaIngreso && (
                                <div className="invalid-feedback">
                                    La fecha de ingreso es obligatoria.
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="costo" className="form-label">Costo</label>
                            <input
                                type="number"
                                step="0.01"
                                name="costo"
                                className={`form-control ${errorLoteCosto ? "is-invalid" : ""}`}
                                id="costo"
                                placeholder="Costo total del lote"
                                value={formularioLote.costo}
                                onChange={manejarCambio}
                            />
                            {errorLoteCosto && (
                                <div className="invalid-feedback">
                                    El costo es obligatorio y debe ser un número decimal.
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="precio" className="form-label">Precio</label>
                            <input
                                type="number"
                                step="0.01"
                                name="precio"
                                className={`form-control ${errorLotePrecio ? "is-invalid" : ""}`}
                                id="precio"
                                placeholder="Precio de venta del lote"
                                value={formularioLote.precio}
                                onChange={manejarCambio}
                            />
                            {errorLotePrecio && (
                                <div className="invalid-feedback">
                                    El precio es obligatorio y debe ser un número decimal.
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="utilidad" className="form-label">Utilidad</label>
                            <input
                                type="number"
                                step="0.01"
                                name="utilidad"
                                className="form-control"
                                id="utilidad"
                                placeholder="Utilidad calculada"
                                value={formularioLote.utilidad}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="cantidad" className="form-label">Cantidad</label>
                            <input
                                type="number"
                                step="1"
                                name="cantidad"
                                className={`form-control ${errorLoteCantidad ? "is-invalid" : ""}`}
                                id="cantidad"
                                placeholder="Cantidad total en este lote"
                                value={formularioLote.cantidad}
                                onChange={manejarCambio}
                            />
                            {errorLoteCantidad && (
                                <div className="invalid-feedback">
                                    La cantidad del lote es obligatoria y debe ser un número entero positivo.
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="existencia" className="form-label">Existencia</label>
                            <input
                                type="number"
                                step="1"
                                name="existencia"
                                className="form-control"
                                id="existencia"
                                placeholder="Existencia actual del lote"
                                value={formularioLote.existencia}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <label htmlFor="enPedido" className="form-label">En Pedido</label>
                            <input
                                type="number"
                                name="enPedido"
                                className="form-control"
                                id="enPedido"
                                value={formularioLote.enPedido}
                                onChange={manejarCambio}
                                min="0"
                                step="1"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="estadoLote" className="form-label">Estado del lote</label>
                            <select
                                className="form-control"
                                id="estadoLote"
                                name="estado"
                                value={formularioLote.estado}
                                onChange={manejarCambio}
                            >
                                <option value="Disponible">Disponible</option>
                                <option value="Agotado">Agotado</option>
                            </select>
                        </div>
                    </div>
                </div>

                <h5 className="mt-4 pb-2 border-bottom text-muted">
                    <i className="fas fa-money-bill-wave me-2 mx-2"></i> Precios por mayoreo
                </h5>
                <div className="row mb-4">
                    <div className="col-12">
                        <button
                            className={`btn btn-sm ${errorLotesPrecios ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                            onClick={agregarLotePrecio}
                        >
                            <i className="fas fa-plus me-2"></i> Agregar nivel de precio
                        </button>
                        <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                            <i className="fas fa-tags me-3 fa-lg text-muted"></i>
                            <p className="mb-0">
                                <strong>Niveles de precio por volumen definidos:</strong>&nbsp;
                                <span className="badge bg-dark">
                                    {lotesPrecios.length}
                                    &nbsp;niveles
                                </span>
                            </p>
                        </div>

                        {lotesPrecios.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: '30%' }}>Cantidad Mínima</th>
                                            <th style={{ width: '40%' }}>Precio por Unidad</th>
                                            <th style={{ width: '15%' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lotesPrecios.map((item, idx) => {
                                            const cantidad = parseInt(item.cantidad);
                                            const precio = parseFloat(item.precio);
                                            const cantidadInvalida = (!Number.isInteger(cantidad) || cantidad < 1 || item.cantidad === "");
                                            const precioInvalido = (isNaN(precio) || precio < 0 || item.precio === "");
                                            const filaInvalida = cantidadInvalida || precioInvalido || item.cantidad === "" || item.precio === "";

                                            return (
                                                <tr key={idx} className={filaInvalida ? 'table-warning' : ''}>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm ${cantidadInvalida ? "is-invalid" : ""}`}
                                                            min="1"
                                                            value={item.cantidad}
                                                            onChange={(e) =>
                                                                manejarLotePrecio(idx, "cantidad", e.target.value)
                                                            }
                                                        />
                                                        {cantidadInvalida && (
                                                            <div className="invalid-feedback">
                                                                Cantidad inválida
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            className={`form-control form-control-sm ${precioInvalido ? "is-invalid" : ""}`}
                                                            value={item.precio}
                                                            onChange={(e) =>
                                                                manejarLotePrecio(idx, "precio", e.target.value)
                                                            }
                                                        />
                                                        {precioInvalido && (
                                                            <div className="invalid-feedback">
                                                                Precio inválido
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light text-danger"
                                                            onClick={() => eliminarLotePrecio(idx)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="alert alert-light border text-muted">
                                <i className="fas fa-info-circle me-2"></i>
                                No hay precios por volumen definidos.
                            </div>
                        )}
                    </div>
                </div>

                <h5 className="mt-4 pb-2 border-bottom text-muted">
                    <i className="fas fa-boxes me-2 mx-2"></i> Asignación de inventario del lote
                </h5>
                <div className="row mb-4">
                    <div className="col-12">
                        <button
                            className={`btn btn-sm ${errorLotesInventario ? 'btn-danger' : 'btn-outline-secondary'} me-2 mb-3`}
                            onClick={agregarLoteInventario}
                        >
                            <i className="fas fa-plus me-2"></i> Asignar ubicación
                        </button>

                        <div className="alert alert-secondary p-2 mb-3 d-flex align-items-center">
                            <i className="fas fa-box-open me-3 fa-lg text-muted"></i>
                            <p className="mb-0">
                                <strong>Existencia total del lote disponible para asignación:</strong>&nbsp;
                                <span className="badge bg-dark">
                                    {
                                        (parseInt(formularioLote.existencia) || 0) -
                                        lotesInventario.reduce((sum, item) => sum + (parseInt(item.existencia) || 0), 0)
                                    }
                                    &nbsp;unidades
                                </span>
                            </p>
                        </div>
                        {lotesInventario.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: '20%' }}>Unidades</th>
                                            <th style={{ width: '40%' }}>Ubicación (Tipo de Inventario)</th>
                                            <th style={{ width: '25%' }}>Estado</th>
                                            <th style={{ width: '15%' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lotesInventario.map((item, idx) => {
                                            const existenciaAsignada = parseInt(item.existencia) || 0;
                                            const existenciaTotal = parseInt(formularioLote.existencia) || 0;
                                            const totalAsignadoPrevia = lotesInventario.filter((_, i) => i !== idx).reduce((sum, i) => sum + (parseInt(i.existencia) || 0), 0);
                                            const existenciaDisponible = existenciaTotal - totalAsignadoPrevia;

                                            const existenciaInvalida = (existenciaAsignada < 0 || item.existencia === "") || (existenciaAsignada > existenciaDisponible);
                                            const tipoInvalido = item.inventarioTipoId === "";

                                            return (
                                                <tr key={idx} className={existenciaInvalida || tipoInvalido ? 'table-warning' : ''}>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm ${existenciaInvalida ? "is-invalid" : ""}`}
                                                            min="0"
                                                            value={item.existencia}
                                                            onChange={(e) => handleLoteInventarioChange(idx, "existencia", e.target.value)}
                                                        />
                                                        {existenciaInvalida && (
                                                            <div className="invalid-feedback">
                                                                Cantidad inválida o excede el límite.
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <select
                                                            className={`form-control form-control-sm ${tipoInvalido ? "is-invalid" : ""}`}
                                                            value={item.inventarioTipoId}
                                                            onChange={(e) => handleLoteInventarioChange(idx, "inventarioTipoId", e.target.value)}
                                                        >
                                                            <option value="">Seleccione tipo</option>
                                                            {listaInventariosTipos?.map((tipo) => (
                                                                <option key={tipo.id} value={tipo.id}>
                                                                    {tipo.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {tipoInvalido && (
                                                            <div className="invalid-feedback">Seleccione un tipo</div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            value={item.estado}
                                                            onChange={(e) => handleLoteInventarioChange(idx, "estado", e.target.value)}
                                                        >
                                                            <option value="Activo">Activo</option>
                                                            <option value="Inactivo">Inactivo</option>
                                                        </select>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light text-danger"
                                                            onClick={() => eliminarLoteInventario(idx)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="alert alert-light border text-muted">
                                <i className="fas fa-map-marker-alt me-2"></i>
                                Asigne unidades del lote a ubicaciones específicas de inventario.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ModalBootstrap>
    );
};

export default ModalLoteProducto;